var map = {
	"./img-manner-activity.svg": 74,
	"./img-manner-baggage.svg": 75,
	"./img-manner-drink.svg": 76,
	"./img-manner-eating.svg": 77,
	"./img-manner-fire.svg": 78,
	"./img-manner-light.svg": 79,
	"./img-manner-papers.svg": 80,
	"./img-manner-pencil.svg": 81,
	"./img-manner-pet.svg": 82,
	"./img-manner-photo.svg": 83,
	"./img-manner-quietness.svg": 84,
	"./img-manner-smoking.svg": 85,
	"./img-manner-tel.svg": 86,
	"./img-manner-touch.svg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;